<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-center">
      <div>
        <Breadcrumbs headline="Báo cáo" :link="[{ text: 'Báo cáo', href: '../exam-reports' }]" />
      </div>
    </div>
    <v-tabs class="mx-md-4" v-model="tab" active-class="tab-active" background-color="transparent">
      <v-tab v-for="item in getTabs" :key="item" class="tab-default">
        {{ item }}
      </v-tab>
    </v-tabs>

    <v-card outlined class="mx-md-4 elevation-0">
      <v-tabs-items touchless v-model="tab" v-if="getTabs.length > 0">
        <v-tab-item v-if="getTabs.includes('Theo khối')" :key="1">
          <GradeExamReport />
        </v-tab-item>
        <v-tab-item v-if="getTabs.includes('Theo lớp')" :key="2">
          <ClassExamReport />
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs.vue'

import GradeExamReport from '../../modules/exam/GradeExamReport.vue'
import ClassExamReport from '../../modules/exam/ClassExamReport.vue'

export default {
  components: {
    Breadcrumbs,
    GradeExamReport,
    ClassExamReport
  },
  data() {
    return {
      tab: null
    }
  },
  computed: {
    getTabs() {
      const tabs = ['Theo khối', 'Theo lớp']

      return tabs
    }
  },
  created() {
    if (this.$route.query.diligence) {
      this.tab = 1
    } else if (this.getTabs.length > 0) {
      this.tab = 0
    }
  }
}
</script>
